import {
  TOGGLE_REMEMBERED,
} from '../constants';

export interface IToggleRemembered {
  type: typeof TOGGLE_REMEMBERED;
}

const showRemembered = (state: boolean = false, action: IToggleRemembered): boolean => {
  switch (action.type) {
    case TOGGLE_REMEMBERED:
      return !state;

    default:
      return state;
  }
};

export default showRemembered;
